import {
  getItemDefaultDisplay,
  getItemValidations,
} from "features/configuration/GeneralConfiguration/utils";
import { toFixed } from "@shared/utils/numbers";
import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";
import { useContext } from "react";
import {
  GeneralConfigurationContext,
  ModalItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import CustomInputNumber from "common/Inputs/CustomInputNumber";

const TextBoxItem = ({ item, ...props }) => {
  const valueParser = (value) =>
    value || value === 0 ? toFixed(value, round) : null;
  const { editable } = useContext(GeneralConfigurationContext);
  const {
    itemValue,
    handleItemChange,
    itemName,
    prefix,
    suffix,
    overrideComponent,
    itemValueModified,
  } = useConfigurationItem({ item, valueParser });
  const defaultDisplay = getItemDefaultDisplay(item);
  const { min, max, round } = getItemValidations(item);
  const { inModal } = useContext(ModalItemContext);

  const handleInputChange = (value) => {
    handleItemChange(value);
  };
  const wrappedPrefix = prefix
    ? prefix.charAt(0) === "("
      ? prefix
      : `(${prefix})`
    : null;
  const wrappedSuffix = suffix
    ? suffix.charAt(0) === "("
      ? suffix
      : `(${suffix})`
    : null;
  const extraInfoComponent = (
    <>
      {wrappedPrefix}
      {wrappedSuffix}
      <CustomInputNumber
        placeholder={defaultDisplay}
        value={itemValue || ""}
        onChange={handleInputChange}
        bordered={false}
        max={max}
        min={min}
        precision={round}
        style={{
          maxWidth: 200,
          marginLeft: !!wrappedSuffix || !!wrappedPrefix ? 8 : 0,
        }}
        $flushPaddingLeft={true}
        disabled={!editable}
        hideArrows={true}
        bgColor="inherit"
        autoSize={props.extraInfoAlignRight}
      />
    </>
  );

  const defaultOverrideComponent = inModal ? null : <span />;
  return (
    <ConfigurationItemRow
      nameComponent={itemName}
      extraInfoComponent={extraInfoComponent}
      overrideComponent={overrideComponent || defaultOverrideComponent}
      itemValueModified={itemValueModified}
    />
  );
};

export default TextBoxItem;
